import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const DAY_MS = 24 * 60 * 60 * 1000;

/** Chat day separator label: Today, Yesterday or `EEE dd MMM yyyy` in the current app language. */
@Pipe({
  name: 'messageDay',
})
export class MessageDayPipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  transform(value: string | Date | null | undefined): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return '';
    }

    const daysAgo = Math.round((this.startOfDay(new Date()) - this.startOfDay(date)) / DAY_MS);

    if (daysAgo === 0) {
      return this.translate.instant('certify.chatbot.messages.today');
    }

    if (daysAgo === 1) {
      return this.translate.instant('certify.chatbot.messages.yesterday');
    }

    return this.formatDate(date);
  }

  // Intl avoids depending on Angular locale data, which the certify host does not register for every language.
  private formatDate(date: Date): string {
    const lang = this.translate.currentLang || this.translate.defaultLang || 'en';
    const parts = new Intl.DateTimeFormat(lang, {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).formatToParts(date);
    const part = (type: Intl.DateTimeFormatPartTypes): string =>
      (parts.find((item) => item.type === type)?.value ?? '').replace('.', '');

    return `${part('weekday')} ${part('day')} ${part('month')} ${part('year')}`;
  }

  private startOfDay(date: Date): number {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  }
}
